import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import DeleteWorkingHoursExceptionsFormModal from 'src/features/workingHoursExceptions/components/form/DeleteWorkingHoursExceptionsFormModal';
import UpdateWorkingHoursExceptionsFormModal from 'src/features/workingHoursExceptions/components/form/UpdateWorkingHoursExceptionsFormModal';
import { WorkingHoursException } from 'src/features/workingHoursExceptions/utils/types';
import { workingHoursMessages } from 'src/features/workingHoursExceptions/utils/messages';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellWorkingHourExceptionActions({ row }: CellContext<WorkingHoursException, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateWorkingHoursExceptionsFormModal
                        selectedWorkingHoursException={row.original}
                        semantics={{
                            entryName: formatMessage(workingHoursMessages.workingHoursException).toLowerCase(),
                        }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateWorkingHoursExceptionsFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteWorkingHoursExceptionsFormModal
                        selectedWorkingHoursException={row.original}
                        semantics={{
                            entryName: formatMessage(workingHoursMessages.workingHoursException).toLowerCase(),
                        }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteWorkingHoursExceptionsFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
